import { SET_PURCHASE_ORDER } from './actionTypes';

export const setPurchaseOrderNumber = (number: string) => {
  return {
    type: SET_PURCHASE_ORDER,
    payload: number,
  };
};
